import { render, staticRenderFns } from "./ContactDistributionsByLanguage.vue?vue&type=template&id=5c70a6b1&scoped=true"
import script from "./ContactDistributionsByLanguage.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByLanguage.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByLanguage.vue?vue&type=style&index=0&id=5c70a6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70a6b1",
  null
  
)

export default component.exports